import { ClaimRecord } from "./claim";
import { Timestamp } from "../../google/protobuf/timestamp";
import { Coin } from "../../cosmos/base/v1beta1/coin";
import { Params } from "./params";
import { Period } from "../vesting/vesting";
import * as _m0 from "protobufjs/minimal";
import { toTimestamp, fromTimestamp } from "@osmonauts/helpers";
function createBaseClaimStatus() {
  return {
    airdropIdentifier: "",
    claimed: false
  };
}
export const ClaimStatus = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.airdropIdentifier !== "") {
      writer.uint32(10).string(message.airdropIdentifier);
    }
    if (message.claimed === true) {
      writer.uint32(16).bool(message.claimed);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.airdropIdentifier = reader.string();
          break;
        case 2:
          message.claimed = reader.bool();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$airdropIdenti, _object$claimed;
    const message = createBaseClaimStatus();
    message.airdropIdentifier = (_object$airdropIdenti = object.airdropIdentifier) !== null && _object$airdropIdenti !== void 0 ? _object$airdropIdenti : "";
    message.claimed = (_object$claimed = object.claimed) !== null && _object$claimed !== void 0 ? _object$claimed : false;
    return message;
  }
};
function createBaseQueryClaimStatusRequest() {
  return {
    address: ""
  };
}
export const QueryClaimStatusRequest = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClaimStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$address;
    const message = createBaseQueryClaimStatusRequest();
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    return message;
  }
};
function createBaseQueryClaimStatusResponse() {
  return {
    claimStatus: []
  };
}
export const QueryClaimStatusResponse = {
  encode(message, writer = _m0.Writer.create()) {
    for (const v of message.claimStatus) {
      ClaimStatus.encode(v, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClaimStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.claimStatus.push(ClaimStatus.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$claimStatus;
    const message = createBaseQueryClaimStatusResponse();
    message.claimStatus = ((_object$claimStatus = object.claimStatus) === null || _object$claimStatus === void 0 ? void 0 : _object$claimStatus.map(e => ClaimStatus.fromPartial(e))) || [];
    return message;
  }
};
function createBaseClaimMetadata() {
  return {
    airdropIdentifier: "",
    currentRound: "",
    currentRoundStart: undefined,
    currentRoundEnd: undefined
  };
}
export const ClaimMetadata = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.airdropIdentifier !== "") {
      writer.uint32(10).string(message.airdropIdentifier);
    }
    if (message.currentRound !== "") {
      writer.uint32(18).string(message.currentRound);
    }
    if (message.currentRoundStart !== undefined) {
      Timestamp.encode(toTimestamp(message.currentRoundStart), writer.uint32(26).fork()).ldelim();
    }
    if (message.currentRoundEnd !== undefined) {
      Timestamp.encode(toTimestamp(message.currentRoundEnd), writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.airdropIdentifier = reader.string();
          break;
        case 2:
          message.currentRound = reader.string();
          break;
        case 3:
          message.currentRoundStart = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          break;
        case 4:
          message.currentRoundEnd = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$airdropIdenti2, _object$currentRound, _object$currentRoundS, _object$currentRoundE;
    const message = createBaseClaimMetadata();
    message.airdropIdentifier = (_object$airdropIdenti2 = object.airdropIdentifier) !== null && _object$airdropIdenti2 !== void 0 ? _object$airdropIdenti2 : "";
    message.currentRound = (_object$currentRound = object.currentRound) !== null && _object$currentRound !== void 0 ? _object$currentRound : "";
    message.currentRoundStart = (_object$currentRoundS = object.currentRoundStart) !== null && _object$currentRoundS !== void 0 ? _object$currentRoundS : undefined;
    message.currentRoundEnd = (_object$currentRoundE = object.currentRoundEnd) !== null && _object$currentRoundE !== void 0 ? _object$currentRoundE : undefined;
    return message;
  }
};
function createBaseQueryClaimMetadataRequest() {
  return {};
}
export const QueryClaimMetadataRequest = {
  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClaimMetadataRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(_) {
    const message = createBaseQueryClaimMetadataRequest();
    return message;
  }
};
function createBaseQueryClaimMetadataResponse() {
  return {
    claimMetadata: []
  };
}
export const QueryClaimMetadataResponse = {
  encode(message, writer = _m0.Writer.create()) {
    for (const v of message.claimMetadata) {
      ClaimMetadata.encode(v, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClaimMetadataResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.claimMetadata.push(ClaimMetadata.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$claimMetadata;
    const message = createBaseQueryClaimMetadataResponse();
    message.claimMetadata = ((_object$claimMetadata = object.claimMetadata) === null || _object$claimMetadata === void 0 ? void 0 : _object$claimMetadata.map(e => ClaimMetadata.fromPartial(e))) || [];
    return message;
  }
};
function createBaseQueryDistributorAccountBalanceRequest() {
  return {
    airdropIdentifier: ""
  };
}
export const QueryDistributorAccountBalanceRequest = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.airdropIdentifier !== "") {
      writer.uint32(10).string(message.airdropIdentifier);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDistributorAccountBalanceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.airdropIdentifier = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$airdropIdenti3;
    const message = createBaseQueryDistributorAccountBalanceRequest();
    message.airdropIdentifier = (_object$airdropIdenti3 = object.airdropIdentifier) !== null && _object$airdropIdenti3 !== void 0 ? _object$airdropIdenti3 : "";
    return message;
  }
};
function createBaseQueryDistributorAccountBalanceResponse() {
  return {
    distributorAccountBalance: []
  };
}
export const QueryDistributorAccountBalanceResponse = {
  encode(message, writer = _m0.Writer.create()) {
    for (const v of message.distributorAccountBalance) {
      Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryDistributorAccountBalanceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.distributorAccountBalance.push(Coin.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$distributorAc;
    const message = createBaseQueryDistributorAccountBalanceResponse();
    message.distributorAccountBalance = ((_object$distributorAc = object.distributorAccountBalance) === null || _object$distributorAc === void 0 ? void 0 : _object$distributorAc.map(e => Coin.fromPartial(e))) || [];
    return message;
  }
};
function createBaseQueryParamsRequest() {
  return {};
}
export const QueryParamsRequest = {
  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  }
};
function createBaseQueryParamsResponse() {
  return {
    params: undefined
  };
}
export const QueryParamsResponse = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.params !== undefined) {
      Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.params = Params.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
    return message;
  }
};
function createBaseQueryClaimRecordRequest() {
  return {
    airdropIdentifier: "",
    address: ""
  };
}
export const QueryClaimRecordRequest = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.airdropIdentifier !== "") {
      writer.uint32(10).string(message.airdropIdentifier);
    }
    if (message.address !== "") {
      writer.uint32(18).string(message.address);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClaimRecordRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.airdropIdentifier = reader.string();
          break;
        case 2:
          message.address = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$airdropIdenti4, _object$address2;
    const message = createBaseQueryClaimRecordRequest();
    message.airdropIdentifier = (_object$airdropIdenti4 = object.airdropIdentifier) !== null && _object$airdropIdenti4 !== void 0 ? _object$airdropIdenti4 : "";
    message.address = (_object$address2 = object.address) !== null && _object$address2 !== void 0 ? _object$address2 : "";
    return message;
  }
};
function createBaseQueryClaimRecordResponse() {
  return {
    claimRecord: undefined
  };
}
export const QueryClaimRecordResponse = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.claimRecord !== undefined) {
      ClaimRecord.encode(message.claimRecord, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClaimRecordResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.claimRecord = ClaimRecord.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    const message = createBaseQueryClaimRecordResponse();
    message.claimRecord = object.claimRecord !== undefined && object.claimRecord !== null ? ClaimRecord.fromPartial(object.claimRecord) : undefined;
    return message;
  }
};
function createBaseQueryClaimableForActionRequest() {
  return {
    airdropIdentifier: "",
    address: "",
    action: 0
  };
}
export const QueryClaimableForActionRequest = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.airdropIdentifier !== "") {
      writer.uint32(10).string(message.airdropIdentifier);
    }
    if (message.address !== "") {
      writer.uint32(18).string(message.address);
    }
    if (message.action !== 0) {
      writer.uint32(24).int32(message.action);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClaimableForActionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.airdropIdentifier = reader.string();
          break;
        case 2:
          message.address = reader.string();
          break;
        case 3:
          message.action = reader.int32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$airdropIdenti5, _object$address3, _object$action;
    const message = createBaseQueryClaimableForActionRequest();
    message.airdropIdentifier = (_object$airdropIdenti5 = object.airdropIdentifier) !== null && _object$airdropIdenti5 !== void 0 ? _object$airdropIdenti5 : "";
    message.address = (_object$address3 = object.address) !== null && _object$address3 !== void 0 ? _object$address3 : "";
    message.action = (_object$action = object.action) !== null && _object$action !== void 0 ? _object$action : 0;
    return message;
  }
};
function createBaseQueryClaimableForActionResponse() {
  return {
    coins: []
  };
}
export const QueryClaimableForActionResponse = {
  encode(message, writer = _m0.Writer.create()) {
    for (const v of message.coins) {
      Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryClaimableForActionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.coins.push(Coin.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$coins;
    const message = createBaseQueryClaimableForActionResponse();
    message.coins = ((_object$coins = object.coins) === null || _object$coins === void 0 ? void 0 : _object$coins.map(e => Coin.fromPartial(e))) || [];
    return message;
  }
};
function createBaseQueryTotalClaimableRequest() {
  return {
    airdropIdentifier: "",
    address: "",
    includeClaimed: false
  };
}
export const QueryTotalClaimableRequest = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.airdropIdentifier !== "") {
      writer.uint32(10).string(message.airdropIdentifier);
    }
    if (message.address !== "") {
      writer.uint32(18).string(message.address);
    }
    if (message.includeClaimed === true) {
      writer.uint32(24).bool(message.includeClaimed);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalClaimableRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.airdropIdentifier = reader.string();
          break;
        case 2:
          message.address = reader.string();
          break;
        case 3:
          message.includeClaimed = reader.bool();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$airdropIdenti6, _object$address4, _object$includeClaime;
    const message = createBaseQueryTotalClaimableRequest();
    message.airdropIdentifier = (_object$airdropIdenti6 = object.airdropIdentifier) !== null && _object$airdropIdenti6 !== void 0 ? _object$airdropIdenti6 : "";
    message.address = (_object$address4 = object.address) !== null && _object$address4 !== void 0 ? _object$address4 : "";
    message.includeClaimed = (_object$includeClaime = object.includeClaimed) !== null && _object$includeClaime !== void 0 ? _object$includeClaime : false;
    return message;
  }
};
function createBaseQueryTotalClaimableResponse() {
  return {
    coins: []
  };
}
export const QueryTotalClaimableResponse = {
  encode(message, writer = _m0.Writer.create()) {
    for (const v of message.coins) {
      Coin.encode(v, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryTotalClaimableResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.coins.push(Coin.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$coins2;
    const message = createBaseQueryTotalClaimableResponse();
    message.coins = ((_object$coins2 = object.coins) === null || _object$coins2 === void 0 ? void 0 : _object$coins2.map(e => Coin.fromPartial(e))) || [];
    return message;
  }
};
function createBaseQueryUserVestingsRequest() {
  return {
    address: ""
  };
}
export const QueryUserVestingsRequest = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUserVestingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.address = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$address5;
    const message = createBaseQueryUserVestingsRequest();
    message.address = (_object$address5 = object.address) !== null && _object$address5 !== void 0 ? _object$address5 : "";
    return message;
  }
};
function createBaseQueryUserVestingsResponse() {
  return {
    spendableCoins: [],
    periods: []
  };
}
export const QueryUserVestingsResponse = {
  encode(message, writer = _m0.Writer.create()) {
    for (const v of message.spendableCoins) {
      Coin.encode(v, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.periods) {
      Period.encode(v, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryUserVestingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          message.spendableCoins.push(Coin.decode(reader, reader.uint32()));
          break;
        case 1:
          message.periods.push(Period.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$spendableCoin, _object$periods;
    const message = createBaseQueryUserVestingsResponse();
    message.spendableCoins = ((_object$spendableCoin = object.spendableCoins) === null || _object$spendableCoin === void 0 ? void 0 : _object$spendableCoin.map(e => Coin.fromPartial(e))) || [];
    message.periods = ((_object$periods = object.periods) === null || _object$periods === void 0 ? void 0 : _object$periods.map(e => Period.fromPartial(e))) || [];
    return message;
  }
};